export const namespaced = true;

/* The 50Fin screen's filters, kept here so they survive leaving the screen.

   The six UTM keys are the canonical names -- the ones the controls bind, the
   ones the request sends and the ones LASapp/admin_apis.py reads via
   keys.UTM_*_ARRAY. Two of them used to disagree: this module declared `source`
   and `utm_media` while get50FinData() built `utm_source` and `utm_medium` off
   the same object, so both were undefined, axios dropped them, and the UTM
   Source and UTM Medium dropdowns filtered nothing at all. See
   src/app-js/utm-filters.js. */
export const state = {
  selected_tab: 0,
  page_number: 1,
  utm_source: [],
  utm_content: [],
  utm_medium: [],
  utm_campaign: [],
  utm_platform: [],
  utm_term: [],
};

export const mutations = {
  SET_FILTER(
    state,
    {
      selected_tab,
      page_number,
      utm_source,
      utm_content,
      utm_medium,
      utm_campaign,
      utm_platform,
      utm_term,
    }
  ) {
    state.selected_tab = selected_tab;
    state.page_number = page_number;
    state.utm_source = utm_source;
    state.utm_content = utm_content;
    state.utm_medium = utm_medium;
    state.utm_campaign = utm_campaign;
    state.utm_platform = utm_platform;
    state.utm_term = utm_term;
  },
};

export const actions = {
  setFilters({ commit }, items) {
    commit("SET_FILTER", items);
  },
};
export const getters = {
  getFilters: (state) => {
    return state;
  },
};
